import React, {useCallback, useEffect, useState} from 'react';
import {Redirect, Route} from 'react-router-dom';
import authService from "../services/authService";
import Loading from "../components/common/Loading";

const ProtectedRoute = ({component: Component, ...rest}) => {
    const [isLoading, setIsLoading] = useState(true);

    const internalUserDefaultRoute = '/';

    const forceToInternalUserPage = () => {
        const isUserLoggedIn = authService.getCurrentUser();
        if (isUserLoggedIn) {
            const isExternalUser = authService.isExternalUser();
            return !isExternalUser;
        }
    };

    const attemptTokenRetrieval = useCallback(async () => {
        // Already authenticated — nothing to do
        if (authService.getCurrentUser()) {
            setIsLoading(false);
            return;
        }

        // No JWT in localStorage — use session cookie to fetch one from Dynamo via /refresh
        try {
            const response = await authService.getTokenFromSessionCookie();
            if (response && response.data && response.data.jwtToken) {
                authService.loginWithToken(response.data.jwtToken);
            }
        } catch (error) {
            // Session cookie absent or refresh rejected — will fall through to /auth redirect
        }
        setIsLoading(false);
    }, []);

    useEffect(() => {
        let mounted = true;
        const initAuth = async () => {
            await attemptTokenRetrieval();
            if (!mounted) return;
        };
        initAuth();
        return () => { mounted = false; };
    }, [attemptTokenRetrieval]);

    return (
        <Route
            {...rest}
            render={props => {
                if (isLoading) {
                    return <Loading />;
                }

                const user = authService.getCurrentUser();

                if (user) {
                    props.location.search = null;
                    if (forceToInternalUserPage()) {
                        return <Redirect to={internalUserDefaultRoute} />;
                    }
                    return <Component {...props} />;
                }

                return (
                    <Redirect
                        to={{
                            pathname: '/auth',
                            state: {from: props.location}
                        }}
                    />
                );
            }}
        />
    );
};

export default ProtectedRoute;
